import styled from 'styled-components';

import Button from 'src/app/components/Elements/Button';

export const OuterContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: calc(100vh - 8rem);
`;

export const ContentContainer = styled.div`
  margin-left: auto;
  margin-right: auto;
  max-width: 58rem;
  width: 100%;
  padding: ${props => props.theme.space['10.0']} ${props => props.theme.space['2.0']}
    ${props => props.theme.space['14.4']};
  flex: 1 1 auto;
  ${props => props.theme.mediaQueries.mediumDown} {
    padding: ${props => props.theme.space.s7} ${props => props.theme.space.s7} ${props => props.theme.space['14.4']};
    max-width: none;
  }
`;

export const ContinueButton = styled(Button)`
  width: 240px;

  ${({ theme }) => theme.mediaQueries.smallDown} {
    width: 100%;
  }
`;
